var cilReload = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M265.614,206.387H456V16H424V149.887L397.863,123.75c-79.539-79.539-208.96-79.54-288.5,0s-79.539,208.96,0,288.5a204.232,204.232,0,0,0,288.5,0l-22.627-22.627c-67.063,67.063-176.182,67.063-243.244,0s-67.063-176.183,0-243.246,176.182-67.063,243.245,0l28.01,28.01H265.614Z' class='ci-primary'/>"];

export { cilReload };
//# sourceMappingURL=cil-reload.js.map
